<template>
  <UContainer>
    <slot />
  </UContainer>
</template>